import styled from 'styled-components';

export const Container = styled.div`
        height: 100vh;
        /* display: grid; */

    figure {
        width: 100%;
        background: red;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url('https://w.wallhaven.cc/full/q6/wallhaven-q62ezd.png');
        /* filter: blur(1px); */
            > h1 {
                font-weight: 600;
            font-size: 36px;
            text-align: center;
            font-family: Arial, Helvetica, sans-serif;
            color: var(--strong-pink);
        }
     }   

   

    section {
        display:flex;
        justify-content: space-around;
        align-items: center;
        line-height: 1em;
        div {
            padding: 20px;
            display: grid;
            justify-items: center;
            width: 400px;
            padding-top: 60px;
            img {
                border:0;
                border-radius: 5px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                max-height: 200px;
                max-width: 200px;
            }

            h1 {
                padding: 5px;
                font-family: Arial, Helvetica, sans-serif;
            }

            p {
                font-family: Arial, Helvetica, sans-serif;
            }

            ul {
                padding: 10px;
                li {
                    transition: 0.3s;
                    &:hover {
                        color: #000;
                    }
                }
            }
        }
    }
`;